module.exports = __webpack_public_path__ + "static/media/1.8e9a2e12.jpg";